'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFundPortfolioConfig = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility.js');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _ramda = require('ramda');

var _functional_utility3 = require('./functional_utility');

var _number_utility = require('./number_utility');

var _number_utility2 = _interopRequireDefault(_number_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderSubColumnHeadingsForExposureBreakDown = function renderSubColumnHeadingsForExposureBreakDown(breakdown, firstColumnHeader) {
  if ((0, _ramda.isNil)(breakdown)) {
    return [];
  }

  var hasTertiaryValue = dataContainsNonNullValues(breakdown.data, "displayTertiaryValue");
  var hasQuaternaryValues = dataContainsNonNullValues(breakdown.data, "displayQuarternaryValue");
  var columnHeaders = [firstColumnHeader];

  if (!(0, _ramda.isNil)(breakdown.headers) && breakdown.headers[1] === 'Equity') {
    var headers = [];
    for (var i = 0; i < breakdown.headers.length; i++) {
      headers[i] = _string_utility2.default.renderFormattedLabel(breakdown.headers[i], 'pdp-portfolio-regional-exposure-' + breakdown.headers[i].toLowerCase());
    }
    return headers;
  } else if (breakdown.flag === "GROSS_VALUE" && hasQuaternaryValues) {
    return (0, _ramda.concat)(columnHeaders, [_string_utility2.default.renderFormattedLabel("Long", 'pdp-portfolio-long-label'), _string_utility2.default.renderFormattedLabel("Short", 'pdp-portfolio-short-label'), _string_utility2.default.renderFormattedLabel("Net", 'pdp-portfolio-net-label'), _string_utility2.default.renderFormattedLabel("Gross", 'pdp-portfolio-gross-label')]);
  } else if (breakdown.flag === "BENCHMARK" && hasQuaternaryValues) {
    return (0, _ramda.concat)(columnHeaders, [_string_utility2.default.renderFormattedLabel("Long", 'pdp-portfolio-long-label'), _string_utility2.default.renderFormattedLabel("Short", 'pdp-portfolio-short-label'), _string_utility2.default.renderFormattedLabel("Net", 'pdp-portfolio-net-label'), _string_utility2.default.renderFormattedLabel("Benchmark", 'Benchmark')]);
  } else if (hasTertiaryValue) {
    return (0, _ramda.concat)(columnHeaders, [_string_utility2.default.renderFormattedLabel("Long", 'pdp-portfolio-long-label'), _string_utility2.default.renderFormattedLabel("Short", 'pdp-portfolio-short-label'), _string_utility2.default.renderFormattedLabel("Net", 'pdp-portfolio-net-label')]);
  } else {
    return (0, _ramda.concat)(columnHeaders, [_string_utility2.default.renderFormattedLabel("Long", 'pdp-portfolio-long-label'), _string_utility2.default.renderFormattedLabel("Short", 'pdp-portfolio-short-label')]);
  }
};

var dataContainsNonNullValues = function dataContainsNonNullValues(arr, key) {
  if ((0, _ramda.isNil)(arr)) {
    return false;
  }

  for (var i = 0; i < arr.length; i++) {
    if (!(0, _ramda.isNil)(arr[i][key])) {
      return true;
    }
  }

  return false;
};

var getFundHoldingsSubHeader = function getFundHoldingsSubHeader(data) {
  if (!(0, _ramda.isNil)(data.fund.fundHoldings) && !(0, _ramda.isNil)(data.fund.fundHoldings.headers)) {
    return data.fund.fundHoldings.headers;
  }

  if ((0, _ramda.includes)("SHOW_FUND_HOLDINGS_SUB_HEADER", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data))) {
    var subHeader = [];
    subHeader.push(_string_utility2.default.renderFormattedLabel("HOLDING", "pdp-portfolio-top-holding-holding"));
    if (!(0, _ramda.isNil)(data.fund.fundHoldings) && (0, _ramda.length)(data.fund.fundHoldings.data) > 0 && !(0, _ramda.isNil)(data.fund.fundHoldings.data[0].displayValue)) {
      subHeader.push(_string_utility2.default.renderFormattedLabel("SECTOR", "pdp-portfolio-sector"));
    }
    if (!(0, _ramda.isNil)(data.fund.fundHoldings) && (0, _ramda.length)(data.fund.fundHoldings.data) > 0 && !(0, _ramda.isNil)(data.fund.fundHoldings.data[0].displaySecondaryValue)) {
      subHeader.push(_string_utility2.default.renderFormattedLabel("MARKET", "pdp-portfolio-top-holding-country"));
    }
    subHeader.push(_string_utility2.default.renderFormattedLabel("WEIGHT", "pdp-portfolio-top-holding-weight"));
    return subHeader;
  }
  return null;
};

var renderSubColumnHeadingsForEmeaSectorBreakdown = function renderSubColumnHeadingsForEmeaSectorBreakdown(breakdown) {
  if ((0, _ramda.isNil)(breakdown)) {
    return [];
  } else if (secondaryPresentForAtLeast1Row(breakdown.data)) {
    return ["", _string_utility2.default.renderFormattedLabel("Fund", "Fund"), _string_utility2.default.renderFormattedLabel("Benchmark", "Benchmark"), _string_utility2.default.renderFormattedLabel("Deviation", 'pdp-portfolio-deviation-label')];
  } else {
    return [];
  }
};

var renderSubColumnHeadingsForRegionalAssetExposureBreakDown = function renderSubColumnHeadingsForRegionalAssetExposureBreakDown(breakdown) {
  var columnHeaders = ["Region"];
  if ((0, _ramda.isNil)(breakdown)) {
    return [];
  } else if (secondaryPresentForAtLeast1Row(breakdown.data)) {
    return (0, _ramda.concat)(columnHeaders, ["Bond", "Convertible Bond", "Equity", "Cash Equivalents"]);
  } else {
    return columnHeaders;
  }
};

var renderSubColumnHeadingsForRegionalBreakDown = function renderSubColumnHeadingsForRegionalBreakDown(breakdown, showFundHeader) {
  if ((0, _ramda.isNil)(breakdown)) {
    return [];
  } else if (secondaryPresentForAtLeast1Row(breakdown.data)) {
    return [_string_utility2.default.renderFormattedLabel("Region", 'pdp-portfolio-region'), _string_utility2.default.renderFormattedLabel("Fund", 'Fund'), _string_utility2.default.renderFormattedLabel("Benchmark", 'Benchmark'), _string_utility2.default.renderFormattedLabel("Deviation", 'pdp-portfolio-deviation-label')];
  } else if (showFundHeader) {
    return ["", _string_utility2.default.renderFormattedLabel("FUND", 'pdp-portfolio-column-header-fund')];
  } else {
    return [];
  }
};

var secondaryPresentForAtLeast1Row = function secondaryPresentForAtLeast1Row(data) {
  return (0, _ramda.length)((0, _ramda.filter)(function (row) {
    return row && !(0, _ramda.isNil)(row.secondaryValue);
  }, data)) > 0;
};

var getDataLengthMinusOne = function getDataLengthMinusOne(fundHoldings) {
  return (0, _ramda.isNil)(fundHoldings) ? "0" : fundHoldings.data.length - 1;
};

var getIndustryBreakdownHeader = function getIndustryBreakdownHeader(data) {
  if (!(0, _ramda.isNil)(data.fund.industryBreakdown) && data.fund.industryBreakdown.data.length === 5) {
    return "Top Five Industries";
  } else {
    return _string_utility2.default.renderFormattedLabel('Industry Breakdown', 'pdp-portfolio-industry-breakdown-label');
  }
};

var getRiskMeasureSubColumnHeader = function getRiskMeasureSubColumnHeader(data, intl) {
  var subColumnHeader = [];
  if (!(0, _ramda.isNil)(data.fund.riskMeasures)) {
    if (data.fund.riskMeasures.flag === '3YR') {
      subColumnHeader = ["", "3 years"];
    } else if (data.fund.riskMeasures.flag === '3YR-5YR') {
      subColumnHeader = ["", "3 years", "5 years"];
    } else if (data.fund.riskMeasures.flag === 'SMA') {
      subColumnHeader = ["", _string_utility2.default.getLocalizedString(data.intl, "Portfolio", "pdp-portfolio-risk-measures-portfolio-label", {}), _string_utility2.default.getLocalizedString(data.intl, "Index", "pdp-portfolio-risk-measures-index-label", {})];
    }
  }
  return subColumnHeader;
};

var getSectorBreakdownFundIndexSubColumnHeader = function getSectorBreakdownFundIndexSubColumnHeader(data) {
  var headers = (0, _functional_utility.pathOrNull)(['fund', 'sectorBreakdownFundIndex', 'headers'], data);
  if (headers && headers.length > 0) {
    return {
      subColumnHeader: headers
    };
  }

  var fundColumnHeader = !data.fund.isSMA ? "Fund" : _string_utility2.default.getLocalizedString(data.intl, "Portfolio", "pdp-portfolio-sector-breakdown-portfolio", {});

  if ((0, _ramda.isNil)(data.fund.sectorBreakdownFundIndex) || (0, _ramda.isNil)(data.fund.sectorBreakdownFundIndex.data[0].secondaryValue)) {
    return {
      subColumnHeader: ["", fundColumnHeader, ""],
      subColumnHeaderSpans: [3, 1, 1],
      showDashOn2ndColumn: 'false'
    };
  } else {
    return {
      subColumnHeader: ["", fundColumnHeader, _string_utility2.default.getLocalizedString(data.intl, "Index", "pdp-portfolio-sector-breakdown-index", {})]
    };
  }
};

var getRegionalBreakdownSubColumnHeader = function getRegionalBreakdownSubColumnHeader(data) {
  var headers = (0, _functional_utility.pathOrNull)(['fund', 'regionalBreakdown', 'headers'], data);
  if (headers && headers.length > 0) {
    return {
      subColumnHeader: headers
    };
  } else {
    return {};
  }
};

var checkStatisticalAnalysisData = function checkStatisticalAnalysisData(fund) {
  var statisticalAnalysis = fund.portfolioStatisticalAnalysis;
  if ((0, _functional_utility3.doesVisibleDataPointContains)('PORTFOLIO_STATISTICAL_ANALYSIS_DATA_CHECK', fund.visibleData, ['visiblePortfolioCards'])) {
    if (statisticalAnalysis != null && statisticalAnalysis.data != null) {
      for (var i = 0; i < statisticalAnalysis.data.length; i++) {
        if (_number_utility2.default.isNilOrHyphen(statisticalAnalysis.data[i].displayValue) && _number_utility2.default.isNilOrHyphen(statisticalAnalysis.data[i].displaySecondaryValue) && _number_utility2.default.isNilOrHyphen(statisticalAnalysis.data[i].displayTertiaryValue) && _number_utility2.default.isNilOrHyphen(statisticalAnalysis.data[i].displayQuarternaryValue)) {
          return [];
        }
      }
    }
  }
  return statisticalAnalysis;
};

var getFundPortfolioConfig = function getFundPortfolioConfig(data) {
  var intl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if ((0, _ramda.isNil)(data)) {
    return null;
  }
  var propOrEmptyObject = function propOrEmptyObject(prop) {
    return prop || {};
  };

  function getTopHoldingLabel(legalStructureCode) {
    var topHoldingMsgKey = "pdp-portfolio-analysis-top-10-holdings";

    if (legalStructureCode === "MAINLAND_FUND") {
      topHoldingMsgKey = "pdp-portfolio-analysis-top-5-holdings";
    }
    return _string_utility2.default.renderFormattedLabel("Top 10 Holdings", topHoldingMsgKey);
  }

  var secondDisclosureText = (0, _ramda.includes)("SHOW_EMEA_VARIOUS_PORTFOLIO_DISCLOSURES", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? data.fund.disclosures.pdpPortfolioTabVariousCards : null;
  var secondPlacementId = (0, _ramda.includes)("SHOW_EMEA_VARIOUS_PORTFOLIO_DISCLOSURES", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? 'pdpPortfolioTabVariousCards' : null;
  return {
    portfolioStats: {
      type: "portfolioChild",
      breakdown: data.fund.portfolioStats,
      header: _string_utility2.default.renderFormattedLabel('Portfolio Stats', 'pdp-portfolio-stats-label'),
      id: "portfolioStatsCard",
      disclosureText: data.fund.disclosures.pdpCardPortfolioStats,
      placementId: "pdpCardPortfolioStats",
      grouping: true,
      disclosures: data.fund.disclosures
    },
    propertyBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.propertyBreakdown,
      header: 'Investment Breakdown',
      id: 'propertyBreakdownCard',
      effectiveDate: propOrEmptyObject(data.fund.propertyBreakdown).effectiveDate,
      subColumnHeader: ["Investment Name", "Location", "Acquisition date", "Ownership", "Units", "Square Footage", "Occupancy", "# of Assets", "Investment Type", "Sector"],
      subColumnHeaderDisclosure: [null, null, null, 'pdpDataPointPropertyBreakdownOwnership', 'pdpDataPointPropertyBreakdownUnits', null, 'pdpDataPointPropertyBreakdownOccupancy', null, null, null],
      disclosures: data.fund.disclosures
    },
    fundHoldings: {
      type: 'portfolioChild',
      breakdown: data.fund.fundHoldings,
      header: (0, _ramda.includes)("SHOW_TOP_10_HOLDINGS_HEADER", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? getTopHoldingLabel(data.fund.fundCompany.legalStructureCode) : "Top " + getDataLengthMinusOne(data.fund.fundHoldings) + " Holdings",
      id: 'holdingsCard',
      hideTable: (0, _ramda.includes)("PORTFOLIO_HIDE_TOP_HOLDINGS_TABLE_AND_DATE", _functional_utility2.default.pathOrEmptyArray(["fund", "visibleData", "visiblePortfolioCards"], data)),
      hideEffectiveDate: (0, _ramda.includes)("PORTFOLIO_HIDE_TOP_HOLDINGS_TABLE_AND_DATE", _functional_utility2.default.pathOrEmptyArray(["fund", "visibleData", "visiblePortfolioCards"], data)),
      disclosureText: (0, _ramda.includes)("SHOW_PORTFOLIO_HOLDINGS_DISCLOSURE", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? data.fund.disclosures.pdpPortfolioTopHoldings : data.fund.disclosures.pdpCardTop10Holdings,
      placementId: 'pdpCardTop10Holdings',
      subColumnHeader: getFundHoldingsSubHeader(data),
      excelDownloadType: function () {
        if ((0, _ramda.includes)("PORTFOLIO_HIDE_TOP_HOLDINGS_DOWNLOAD_BUTTON", _functional_utility2.default.pathOrEmptyArray(["fund", "visibleData", "visiblePortfolioCards"], data))) {
          return null;
        }
        return !(0, _ramda.isNil)(data.fund.dailyHoldings) ? 'dailyMFHoldings' : null;
      }(),
      showDashOn2ndColumn: "false"
    },
    monthlyHoldings: {
      type: 'portfolioChild',
      breakdown: (0, _functional_utility.pathOrNull)(['fund', 'holdings', 'monthlyHoldings'], data),
      id: 'monthlyHoldingsCard',
      hideTable: true,
      header: _string_utility2.default.renderFormattedLabel("All Holdings", "pdp-portfolio-monthly-holdings-table-title"),
      downloadBtnLabel: _string_utility2.default.renderFormattedLabel("Download all holdings (PDF)", "pdp-daily-holdings-download-button-pdf"),
      effectiveDate: (0, _functional_utility.pathOrNull)(['fund', 'holdings', 'monthlyHoldings', 'effectiveDate'], data),
      excelDownloadType: 'monthlyMFHoldings',
      showDownloadButton: true
    },
    deltaGamma: {
      type: 'portfolioChild',
      breakdown: (0, _functional_utility.pathOrNull)(['fund', 'breakdowns', 'deltaGamma'], data),
      hideTable: (0, _ramda.includes)("PORTFOLIO_HIDE_TABLE_CONTENT", _functional_utility2.default.pathOrEmptyArray(["fund", "visibleData", "formattingRules"], data)),
      hideTOCTitle: (0, _ramda.includes)("PORTFOLIO_HIDE_TOC", _functional_utility2.default.pathOrEmptyArray(["fund", "visibleData", "formattingRules"], data)),
      header: _string_utility2.default.renderFormattedLabel('Supplemental Information', 'pdp-portfolio-delta-gamma-table-title'),
      id: 'deltaGammaPortfolioCard',
      placementId: 'pdpCardELNDeltaGamma',
      disclosureText: data.fund.disclosures.pdpCardELNDeltaGamma,
      excelDownloadType: 'deltaGamma',
      downloadBtnLabel: _string_utility2.default.renderFormattedLabel("Download ELN Data", "pdp-portfolio-delta-gamma-excel-button-label"),
      showDownloadButton: true,
      controllerType: 'excel',
      subColumnHeader: []
    },
    globalMacro: {
      type: 'portfolioChild',
      breakdown: data.fund.globalMacro,
      header: _string_utility2.default.renderFormattedLabel('Global macro', 'pdp-portfolio-global-macro'),
      id: 'globalMacroCard',
      subColumnHeader: [_string_utility2.default.renderFormattedLabel("Top positions", 'pdp-portfolio-top-positions'), "", ""]
    },
    portfolioSectorBreakdown: {
      type: 'portfolioHoldingChildCard',
      breakdown: data.fund.portfolioSectorBreakdown,
      header: 'Portfolio Breakdown',
      id: 'portfolioSectorBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioHoldings,
      placementId: 'pdpCardPortfolioHoldings',
      effectiveDate: propOrEmptyObject(data.fund.portfolioSectorBreakdown).effectiveDate
    },
    portfolioDistribution: {
      type: 'portfolioHoldingChildCard',
      breakdown: data.fund.portfolioDistribution,
      header: 'Portfolio Holdings',
      id: 'portfolioDistributionCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioHoldings,
      placementId: 'pdpCardPortfolioHoldings',
      effectiveDate: propOrEmptyObject(data.fund.portfolioDistribution).effectiveDate
    },
    portfolioHoldings: {
      type: 'portfolioHoldingChildCard',
      breakdown: data.fund.portfolioHoldings,
      header: 'Portfolio Holdings',
      id: 'portfolioHoldingsBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioHoldings,
      placementId: 'pdpCardPortfolioHoldings',
      effectiveDate: propOrEmptyObject(data.fund.portfolioHoldings).effectiveDate
    },
    accessPortfolioAllocation: {
      type: 'portfolioAccessAllocation',
      breakdown: data.fund.accessPortfolioAllocation,
      header: 'Portfolio Holdings',
      id: 'accessPortfolioAllocationsCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioBreakdown,
      placementId: 'pdpCardPortfolioBreakdown',
      grouping: true,
      effectiveDate: propOrEmptyObject(data.fund.accessPortfolioAllocation).effectiveDate
    },
    sampleWithdrawal: {
      type: 'portfolioChild',
      breakdown: (0, _functional_utility.pathOrNull)(['fund', 'breakdowns', 'sampleWithdrawalAmount'], data),
      header: _string_utility2.default.renderFormattedLabel('Sample Withdrawal Amount', 'pdp-portfolio-sample-withdrawal'),
      id: 'sampleWithdrawalCard',
      disclosureText: data.fund.disclosures.pdpDataPointSampleWithdrawalAmount,
      placementId: 'pdpDataPointSampleWithdrawalAmount'
    },
    sectorExposure: {
      type: 'portfolioChild',
      breakdown: data.fund.sectorExposure,
      header: _string_utility2.default.renderFormattedLabel('Sector Exposure', 'pdp-portfolio-sector-exposure'),
      id: 'sectorExposureCard',
      disclosureText: data.fund.disclosures.pdpCardSectorExposure,
      placementId: 'pdpCardSectorExposure',
      subColumnHeader: ["", "", "", "FUND"]
    },
    sectorBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.sectorBreakdown,
      header: 'Sector Breakdown',
      id: 'sectorBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardSectorBreakdown,
      placementId: 'pdpCardSectorBreakdown',
      subColumnHeader: ["", "LONG", "SHORT"]
    },
    sectorBreakdownFundIndex: _extends({
      type: 'portfolioChild',
      breakdown: data.fund.sectorBreakdownFundIndex,
      header: (0, _ramda.includes)("SHOW_TOP_FIVE_SECTOR_TITLE", _functional_utility2.default.pathOrEmptyArray(["fund", "visibleData", "visiblePortfolioCards"], data)) ? "Top 5 Sectors" : _string_utility2.default.getLocalizedString(data.intl, "Sector Breakdown", "pdp-portfolio-sector-breakdown-header", {}),
      id: 'sectorBreakdownFundIndexCard',
      disclosureText: data.fund.disclosures.pdpCardSectorBreakdown,
      placementId: 'pdpCardSectorBreakdown',
      disclosures: data.fund.disclosures
    }, getSectorBreakdownFundIndexSubColumnHeader(data)),
    sectorBreakdownMmkt: {
      type: 'portfolioChild',
      breakdown: data.fund.sectorBreakdownMMKT,
      header: 'Sector Breakdown',
      id: 'sectorBreakdownMMKTCard',
      disclosureText: data.fund.disclosures.pdpCardSectorBreakdown,
      placementId: 'pdpCardSectorBreakdown',
      subColumnHeader: ["", "", "", "Fund"]
    },
    sectorBreakdownAggregate: {
      type: 'portfolioChild',
      breakdown: data.fund.sectorBreakdownAggregate,
      header: 'Sector Breakdown',
      id: 'sectorBreakdownAggregate',
      disclosureText: data.fund.disclosures.pdpCardSectorBreakdown,
      placementId: 'pdpCardSectorBreakdown'
    },
    assetAllocation: {
      type: 'portfolioChild',
      breakdown: data.fund.assetAllocation,
      header: _string_utility2.default.renderFormattedLabel('Asset Allocation', 'pdp-portfolio-asset-allocation-label', { role: data.role }),
      id: 'assetAllocationCard',
      disclosureText: data.fund.disclosures.pdpCardAssetAllocation,
      placementId: 'pdpCardAssetAllocation',
      secondDisclosureText: secondDisclosureText,
      secondPlacementId: secondPlacementId
    },
    portfolioBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioBreakdown,
      header: _string_utility2.default.renderFormattedLabel('Portfolio Breakdown', 'pdp-portfolio-breakdown-label'),
      id: 'portfolioBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioBreakdown,
      placementId: 'pdpCardPortfolioBreakdown'
    },
    riskMeasures: {
      type: 'portfolioChild',
      breakdown: data.fund.riskMeasures,
      header: _string_utility2.default.renderFormattedLabel('Risk measures', 'pdp-portfolio-risk-measures-label'),
      id: 'riskMeasuresCard',
      disclosureText: data.fund.disclosures.pdpCardRiskMeasures,
      placementId: 'pdpCardRiskMeasures',
      disclosures: data.fund.disclosures,
      subColumnHeader: getRiskMeasureSubColumnHeader(data)
    },
    quarterlyContributors: {
      type: 'portfolioChild',
      breakdown: data.fund.quarterlyContributors,
      header: "Top " + (getDataLengthMinusOne(data.fund.quarterlyContributors) + 1) + " Quarterly Contributors",
      id: 'quarterlyContributorsCard',
      disclosureText: data.fund.disclosures.pdpCardTopNQuarterlyContributors,
      placementId: 'pdpCardTopNQuarterlyContributors'
    },
    quarterlyDetractors: {
      type: 'portfolioChild',
      breakdown: data.fund.quarterlyDetractors,
      header: "Top " + (getDataLengthMinusOne(data.fund.quarterlyDetractors) + 1) + " Quarterly Detractors",
      id: 'quarterlyDetractorsCard',
      disclosureText: data.fund.disclosures.pdpCardTopNQuarterlyDetractors,
      placementId: 'pdpCardTopNQuarterlyDetractors'
    },
    regionalBreakdown: _extends({
      type: 'portfolioChild',
      breakdown: data.fund.regionalBreakdown,
      header: 'Regional Breakdown',
      id: 'regionalBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardRegionalBreakdown,
      placementId: 'pdpCardRegionalBreakdown',
      disclosures: data.fund.disclosures
    }, getRegionalBreakdownSubColumnHeader(data)),
    regionalDistribution: {
      type: 'portfolioChild',
      breakdown: data.fund.regionalDistribution,
      header: 'Regional Distribution',
      id: 'regionalDistributionCard',
      disclosureText: data.fund.disclosures.pdpCardRegionalDistribution,
      placementId: 'pdpCardRegionalDistribution'
    },
    countryBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.countryBreakdown,
      header: 'Country Breakdown',
      id: 'countryBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardCountryBreakdown,
      placementId: 'pdpCardCountryBreakdown'
    },
    currencyAllocation: {
      type: 'portfolioChild',
      breakdown: data.fund.currencyAllocation,
      header: _string_utility2.default.renderFormattedLabel('Currency Allocation', 'pdp-portfolio-currency-allocation-label'),
      id: 'currencyAllocationCard',
      disclosureText: data.fund.disclosures.pdpCardCurrencyAllocation,
      placementId: 'pdpCardCurrencyAllocation'
    },
    qualityBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.qualityBreakdown,
      header: _string_utility2.default.renderFormattedLabel('Quality', 'pdp-portfolio-quality-label'),
      id: 'qualityBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardQualityBreakdown,
      subColumnHeader: (0, _ramda.isNil)(data.fund.qualityBreakdown) || (0, _ramda.all)(function (val) {
        return (0, _ramda.isNil)(val.secondaryValue);
      })(data.fund.qualityBreakdown.data) ? null : ["", _string_utility2.default.renderFormattedLabel("Fund", "pdp-portolio-fund-label"), _string_utility2.default.renderFormattedLabel("Index", "pdp-portolio-index-label")]
    },

    averageLife: {
      type: 'portfolioChild',
      breakdown: data.fund.averageLife,
      header: _string_utility2.default.renderFormattedLabel('Average Life', 'pdp-portfolio-average-life-label'),
      id: 'averageLifeCard',
      disclosureText: data.fund.disclosures.pdpCardAverageLife,
      placementId: 'pdpCardAverageLife'
    },
    couponType: {
      type: 'portfolioChild',
      breakdown: (0, _functional_utility.pathOrNull)(['fund', 'breakdowns', 'couponType'], data),
      header: _string_utility2.default.renderFormattedLabel('Coupon Type', 'pdp-portfolio-coupon-type-label'),
      id: 'couponTypeCard',
      disclosureText: data.fund.disclosures.pdpCardCouponType,
      placementId: 'pdpCardCouponType'
    },
    issueType: {
      type: 'portfolioChild',
      breakdown: (0, _functional_utility.pathOrNull)(['fund', 'breakdowns', 'issueType'], data),
      header: _string_utility2.default.renderFormattedLabel('Issue Type', 'pdp-portfolio-issue-type-label'),
      id: 'issueTypeCard',
      disclosureText: data.fund.disclosures.pdpCardIssueType,
      placementId: 'pdpCardIssueType'
    },
    securityType: {
      type: 'portfolioChild',
      breakdown: (0, _functional_utility.pathOrNull)(['fund', 'breakdowns', 'securityType'], data),
      header: _string_utility2.default.renderFormattedLabel('Security Type', 'pdp-portfolio-security-type-label'),
      id: 'securityTypeCard',
      disclosureText: data.fund.disclosures.pdpCardSecurityType,
      placementId: 'pdpCardSecurityType'
    },
    contractIssuer: {
      type: 'portfolioChild',
      breakdown: (0, _functional_utility.pathOrNull)(['fund', 'breakdowns', 'contractIssuer'], data),
      header: _string_utility2.default.renderFormattedLabel('Contract Issuer', 'pdp-portfolio-contract-issuer-label'),
      subColumnHeader: (0, _ramda.pathOr)([], ['fund', 'breakdowns', 'contractIssuer', 'headers'], data),
      id: 'contractIssuerCard'
    },
    contributionToDuration: {
      type: 'portfolioChild',
      breakdown: data.fund.contributionToDuration,
      header: _string_utility2.default.renderFormattedLabel('Contribution To Duration (in years)', 'pdp-portfolio-contribution-to-duration-label'),
      id: 'contributionToDurationCard',
      disclosureText: data.fund.disclosures.pdpCardContributionToDuration,
      placementId: 'pdpCardContributionToDuration'
    },
    yieldToMaturity: {
      type: 'portfolioChild',
      breakdown: data.fund.yieldToMaturity,
      header: _string_utility2.default.renderFormattedLabel('Yield To Maturity', "pdp-portfolio-yield-to-maturity-label"),
      id: 'yieldToMaturityCard',
      disclosureText: data.fund.disclosures.pdpCardYieldToMaturity,
      placementId: 'pdpCardYieldToMaturity'
    },
    portfolioAllocationTotals: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAllocationTotals,
      header: 'Portfolio Allocation',
      id: 'portfolioAllocationCardTotals',
      disclosureText: data.fund.disclosures.pdpCardPortfolioAllocation,
      placementId: 'pdpCardPortfolioAllocation'
    },
    portfolioAllocation: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAllocation,
      header: 'Portfolio Allocation',
      id: 'portfolioAllocationCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioAllocation,
      placementId: 'pdpCardPortfolioAllocation'
    },
    portfolioAllocationMmaf: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAllocationMMAF,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Allocation", "pdp-portfolio-portfolio-allocation-mmaf-label"),
      id: 'portfolioAllocationMMAFCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioAllocation,
      placementId: 'pdpCardPortfolioAllocation',
      grouping: true
    },
    strategicAllocation: {
      type: 'portfolioChild',
      breakdown: data.fund.strategicAllocation,
      header: 'Strategic Allocation',
      id: 'strategicAllocationCard',
      disclosureText: data.fund.disclosures.pdpCardStrategicAllocation,
      placementId: 'pdpCardStrategicAllocation'
    },
    countryExposure: {
      type: 'portfolioChild',
      breakdown: data.fund.countryExposure,
      header: !data.fund.isSMA ? _string_utility2.default.renderFormattedLabel('Country Allocation', "pdp-portfolio-country-allocation-label") : 'Country Exposure',
      id: 'countryExposureCard',
      disclosureText: data.fund.disclosures.pdpCardCountryExposure,
      placementId: 'pdpCardCountryExposure',
      subColumnHeader: (0, _functional_utility3.doesVisibleDataPointContains)('PORTFOLIO_REGIONAL_BREAKDOWN_HEADER', data.fund.visibleData, ['formattingRules']) ? ["", _string_utility2.default.renderFormattedLabel("FUND", 'pdp-portfolio-column-header-fund')] : [],
      grouping: !!(0, _ramda.isNil)(data.fund.isSMA)
    },
    visibleCharts: {
      type: 'chartParent',
      breakdown: data.fund.visibleData.visibleCharts,
      disclosureText: data.fund.disclosures.pdpCardCountryExposure,
      placementId: 'pdpCardCountryExposure',
      id: 'visibleCharts',
      grouping: true,
      disclosures: data.fund.disclosures,
      effectiveDate: propOrEmptyObject(data.fund.shareClass).shareClassInceptionDate,
      inceptionDate: data.fund.fundInceptionDate
    },
    wamCard: {
      type: 'weightedCard',
      breakdown: data.historicalData,
      header: 'Weighted Average Maturity (in days)',
      id: 'wamCard',
      disclosureText: data.fund.disclosures.pdpCardWam,
      placementId: 'pdpCardWam'
    },
    walCard: {
      type: 'weightedCard',
      breakdown: data.historicalData,
      header: 'Weighted Average Life (in days)',
      id: 'walCard',
      disclosureText: data.fund.disclosures.pdpCardWal,
      placementId: 'pdpCardWal'
    },
    maturity: {
      type: 'portfolioChild',
      breakdown: data.fund.maturity,
      header: _string_utility2.default.renderFormattedLabel('Maturity', 'pdp-portfolio-maturity'),
      id: 'maturityCard',
      disclosureText: data.fund.disclosures.pdpCardMaturity,
      placementId: 'pdpCardMaturity'
    },
    sectorAllocation: {
      type: 'portfolioChild',
      breakdown: data.fund.sectorAllocation,
      header: 'Sector Allocation',
      id: 'sectorAllocationCard',
      disclosureText: data.fund.disclosures.pdpCardSectorAllocation,
      placementId: 'pdpCardSectorAllocation'
    },
    creditLongShortWithChange: {
      type: 'portfolioLongShortChild',
      breakdown: data.fund.creditLongShortWithChange,
      header: 'Long/Shorts (%)',
      id: 'portfolioLongShortWithChangeChildCard',
      disclosureText: data.fund.disclosures.pdpCardLongShortsHistorical,
      placementId: 'pdpCardLongShortsHistorical',
      grouping: true
    },
    riskAnalysis: {
      type: 'portfolioChild',
      breakdown: data.fund.riskAnalysis,
      header: 'Risk Analysis',
      id: 'riskAnalysisCard',
      disclosureText: data.fund.disclosures.pdpCardRiskAnalysis,
      placementId: 'pdpCardRiskAnalysis',
      subColumnHeader: ["", "ANNUALIZED VOLATILITY", "CORRELATION TO FUND"]
    },
    etfFairValuation: {
      type: 'portfolioChild',
      breakdown: data.fund.etfFairValuation,
      header: 'Fair Value/Halted Securities',
      id: 'etfFairValuationCard',
      placementId: 'pdpCardFairValHaltedSec',
      disclosureText: data.fund.disclosures.pdpCardFairValHaltedSec,
      subColumnHeader: ["Security Identifier", "Security Name", "Portfolio Weight"],
      subColumnAlignment: ['left', 'left', 'right']
    },
    commodityInvestment: {
      type: 'portfolioChild',
      breakdown: data.fund.commodityInvestment,
      header: 'Commodity-Linked Investments',
      id: 'commodityInvestmentCard',
      disclosureText: data.fund.disclosures.pdpCardCommodityLinkedInvestments,
      placementId: 'pdpCardCommodityLinkedInvestments',
      grouping: true
    },
    commodityAllocations: {
      type: 'portfolioChild',
      breakdown: data.fund.commodityAllocations,
      header: 'Commodity Allocation',
      id: 'commodityAllocationCard',
      disclosureText: data.fund.disclosures.pdpCardCommodityAllocation,
      placementId: 'pdpCardCommodityAllocation',
      subColumnHeader: ["", "Fund", "Index"]
    },
    fixedIncomeMaturity: {
      type: 'portfolioChild',
      breakdown: data.fund.fixedIncomeMaturity,
      header: 'Fixed Income Maturity',
      id: 'fixedIncomeMaturityCard',
      disclosureText: data.fund.disclosures.pdpCardFixedIncomeMaturity,
      placementId: 'pdpCardFixedIncomeMaturity'
    },
    commodityMaturity: {
      type: 'portfolioChild',
      breakdown: data.fund.commodityMaturity,
      header: 'Commodity Maturity',
      id: 'commodityMaturityCard',
      disclosureText: data.fund.disclosures.pdpCardCommodityMaturity,
      placementId: 'pdpCardCommodityMaturity'
    },
    creditLongShort: {
      type: 'portfolioChild',
      breakdown: data.fund.creditLongShort,
      header: 'Long/Shorts (%)',
      id: 'creditLongShortCard',
      disclosureText: data.fund.disclosures.pdpCardLongShorts,
      placementId: 'pdpCardLongShorts',
      additionalCheck: (0, _ramda.isNil)(data.fund.creditLongShortWithChange)
    },
    portfolioExposure: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioExposure,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Exposure", 'pdp-portfolio-exposure-label'),
      id: 'portfolioExposureCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioExposure,
      placementId: 'pdpCardPortfolioExposure',
      subColumnHeader: ["", _string_utility2.default.renderFormattedLabel('NET', 'pdp-portfolio-net-label'), _string_utility2.default.renderFormattedLabel('GROSS', 'pdp-portfolio-gross-label')]
    },
    notionalExposure: {
      type: 'portfolioChild',
      breakdown: data.fund.notionalExposure,
      header: 'Notional Exposure',
      id: 'notionalExposureCard',
      disclosureText: data.fund.disclosures.pdpCardNotionalExposure,
      placementId: 'pdpCardNotionalExposure',
      subColumnHeader: ["", "LONG", "SHORT"]
    },
    industryBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.industryBreakdown,
      header: getIndustryBreakdownHeader(data),
      id: 'industryBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardIndustryBreakdown,
      placementId: 'pdpCardIndustryBreakdown'
    },
    geographicBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.geographicBreakdown,
      header: 'Regional Breakdown',
      id: 'geographicBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardRegionalBreakdown,
      placementId: 'pdpCardRegionalBreakdown'
    },
    longPositions: {
      type: 'portfolioChild',
      breakdown: data.fund.longPositions,
      header: "Top " + getDataLengthMinusOne(data.fund.longPositions) + " Long Positions",
      id: 'longPositionsCard',
      disclosureText: data.fund.disclosures.pdpCardTopNLongPositions,
      placementId: 'pdpCardTopNLongPositions'
    },
    shortPositions: {
      type: 'portfolioChild',
      breakdown: data.fund.shortPositions,
      header: "Top " + getDataLengthMinusOne(data.fund.shortPositions) + " Short Positions",
      id: 'shortPositionsCard',
      disclosureText: data.fund.disclosures.pdpCardTopNShortPositions,
      placementId: 'pdpCardTopNShortPositions'
    },
    emeaSectorBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.emeaSectorBreakdown,
      header: _string_utility2.default.renderFormattedLabel('Sector breakdown', 'pdp-portfolio-sector-breakdown', { role: data.role }),
      id: 'emeaSectorBreakdownCard',
      subColumnHeader: renderSubColumnHeadingsForEmeaSectorBreakdown(data.fund.emeaSectorBreakdown),
      placementId: 'pdpCardSectorBreakdown',
      disclosureText: data.fund.disclosures.pdpCardSectorBreakdown,
      secondDisclosureText: secondDisclosureText,
      secondPlacementId: secondPlacementId
    },
    marketPositions: {
      type: 'portfolioChild',
      breakdown: data.fund.marketPositions,
      header: _string_utility2.default.renderFormattedLabel('Market positions', 'pdp-portfolio-market-positions'),
      id: 'marketPositionsCard',
      subColumnHeader: renderSubColumnHeadingsForEmeaSectorBreakdown(data.fund.marketPositions),
      placementId: 'pdpCardMarketPositionsBreakdown',
      disclosureText: data.fund.disclosures.pdpCardMarketPositionsBreakdown,
      secondDisclosureText: secondDisclosureText,
      secondPlacementId: secondPlacementId
    },
    bondQualityBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.bondQualityBreakdown,
      header: _string_utility2.default.renderFormattedLabel('Bond Quality Breakdown', 'pdp-portfolio-bond-quality-label', { role: data.role }),
      id: 'bondQualityBreakdownCard',
      placementId: 'pdpCardQualityBreakdown',
      disclosureText: data.fund.disclosures.pdpCardQualityBreakdown,
      shouldAlwaysShowMore: (0, _ramda.includes)("ALWAYS_SHOW_MORE_DISCLOSURES", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)),
      secondDisclosureText: secondDisclosureText,
      secondPlacementId: secondPlacementId
    },
    keyCharacteristics: {
      type: 'portfolioChild',
      breakdown: data.fund.keyCharacteristics,
      header: _string_utility2.default.renderFormattedLabel('Key Characteristics', 'pdp-portfolio-key-Characteristics-label'),
      id: 'keyCharacteristicsBreakdownCard',
      placementId: 'pdpCardKeyCharacteristicsBreakdown'
    },
    portfolioCharacteristics: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioCharacteristics,
      header: _string_utility2.default.renderFormattedLabel("Portfolio characteristics", "pdp-portfolio-characteristics-label", { role: data.role }),
      subColumnHeader: (0, _ramda.includes)("SHOW_BOND_QUALITY_SUB_HEADER_IN_PORTFOLIO_CHARACTERISTICS_CARD", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? [_string_utility2.default.renderFormattedLabel('Bond Quality', 'pdp-portfolio-bond-quality-label'), ""] : null,
      id: 'portfolioCharacteristicsCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioCharacteristics,
      placementId: "pdpCardPortfolioCharacteristics"
    },
    portfolioStatisticalAnalysis: {
      type: 'portfolioChild',
      breakdown: checkStatisticalAnalysisData(data.fund),
      header: _string_utility2.default.renderFormattedLabel("Portfolio Statistical Analysis", "pdp-portfolio-statistical-analysis-card-header"),
      id: 'portfolioStatisticalAnalysisCard',
      disclosureText: data.fund.disclosures.pdpCardStatisticalAnalysis,
      placementId: "pdpCardStatisticalAnalysis",
      subColumnHeader: (0, _ramda.includes)("PORTFOLIO_STATISTICAL_ANALYSIS_1YEAR_SUB_COLUMN", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? ["", _string_utility2.default.renderFormattedLabel("1 YEAR", "pdp-portfolio-statistical-analysis-one-year-header"), _string_utility2.default.renderFormattedLabel("3 YEARS", "pdp-portfolio-statistical-analysis-three-years-header"), _string_utility2.default.renderFormattedLabel("5 YEARS", "pdp-portfolio-statistical-analysis-five-years-header"), _string_utility2.default.renderFormattedLabel("SINCE LAUNCH", "pdp-portfolio-statistical-analysis-since-launch-header")] : ["", _string_utility2.default.renderFormattedLabel("3 YEARS", "pdp-portfolio-statistical-analysis-three-years-header"), _string_utility2.default.renderFormattedLabel("5 YEARS", "pdp-portfolio-statistical-analysis-five-years-header"), _string_utility2.default.renderFormattedLabel("SINCE LAUNCH", "pdp-portfolio-statistical-analysis-since-launch-header")]
    },
    portfolioAnalysis: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysis,
      header: _string_utility2.default.renderFormattedLabel('Portfolio Analysis', 'pdp-portfolio-portfolio-analysis'),
      id: 'portfolioAnalysisCard',
      subColumnHeader: ["", _string_utility2.default.renderFormattedLabel("Long", 'pdp-portfolio-long-label'), _string_utility2.default.renderFormattedLabel("Short", 'pdp-portfolio-short-label')]
    },
    multiPortfolioAnalysis: {
      type: 'portfolioChild',
      breakdown: data.fund.multiPortfolioAnalysis,
      header: _string_utility2.default.renderFormattedLabel('Portfolio Analysis', 'pdp-portfolio-portfolio-analysis'),
      id: "multiPortfolioAnalysis",
      subColumnHeader: propOrEmptyObject(data.fund.multiPortfolioAnalysis).headers,
      showDashOn2ndColumn: "false"
    },
    portfolioAnalysisByCountry: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisByCountry,
      header: _string_utility2.default.renderFormattedLabel('Portfolio Analysis - Market', 'pdp-portfolio-analysis-by-country-region'),
      id: 'portfolioAnalysisByCountryRegion',
      disclosureText: data.fund.disclosures.portfolioAnalysisByCountryRegion,
      placementId: 'portfolioAnalysisByCountryRegion'
    },
    portfolioAnalysisBySector: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisBySector,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Analysis - By Sector", "pdp-portfolio-analysis-by-sector"),
      id: 'portfolioAnalysisBySectorCard',
      subColumnHeader: renderSubColumnHeadingsForEmeaSectorBreakdown(data.fund.portfolioAnalysisBySector)
    },
    regionalAssetExposure: {
      type: 'portfolioChild',
      breakdown: data.fund.regionalAssetExposure,
      header: 'Regional Asset Exposure',
      id: 'regionalAssetBreakdownCard',
      grouping: true,
      subColumnHeader: renderSubColumnHeadingsForRegionalAssetExposureBreakDown(data.fund.regionalAssetExposure)
    },
    emeaSectorExposure: {
      type: 'portfolioChild',
      breakdown: data.fund.emeaSectorExposure,
      header: _string_utility2.default.renderFormattedLabel('Sector exposure', 'pdp-portfolio-sector-exposure'),
      id: 'sectorExposureCard',
      subColumnHeader: renderSubColumnHeadingsForExposureBreakDown(data.fund.emeaSectorExposure, _string_utility2.default.renderFormattedLabel("Sector", 'pdp-portfolio-sector')),
      additionalCheck: (0, _ramda.isNil)(data.fund.equityLongShortOpenPositions) || (0, _ramda.isNil)(data.fund.equityLongShortMarketCap),
      disclosureText: data.fund.disclosures.pdpSectorExposure,
      placementId: 'pdpSectorExposure',
      secondDisclosureText: secondDisclosureText,
      secondPlacementId: secondPlacementId
    },
    emeaRegionalExposure: {
      type: 'portfolioChild',
      breakdown: data.fund.emeaRegionalExposure,
      header: _string_utility2.default.renderFormattedLabel('Regional exposure', 'pdp-portfolio-regional-exposure', { role: data.role }),
      id: 'regionalExposureCard',
      grouping: false,
      subColumnHeader: renderSubColumnHeadingsForExposureBreakDown(data.fund.emeaRegionalExposure, _string_utility2.default.renderFormattedLabel("Region", 'pdp-portfolio-region')),
      secondDisclosureText: secondDisclosureText,
      secondPlacementId: secondPlacementId
    },
    emeaCurrencyExposure: {
      type: 'portfolioChild',
      breakdown: data.fund.emeaCurrencyExposure,
      header: _string_utility2.default.renderFormattedLabel('Currency exposure', 'pdp-portfolio-currency-exposure', { role: data.role }),
      id: 'currencyExposureCard',
      grouping: true
    },
    regionalBreakdownDuration: {
      type: 'portfolioChild',
      breakdown: data.fund.regionalBreakdownDuration,
      header: _string_utility2.default.renderFormattedLabel("Regional Breakdown by Duration", "pdp-portfolio-regional-breakdown-duration-label"),
      id: 'regionalBreakdownByDurationCard',
      placementId: 'pdpRegionalBreakDownBreakdown',
      subColumnHeader: ["Region", _string_utility2.default.renderFormattedLabel("Weighted Duration (yrs)", "pdp-portfolio-weighted-duration-label")]
    },
    marketExposure: {
      type: 'portfolioChild',
      breakdown: data.fund.marketExposure,
      header: _string_utility2.default.renderFormattedLabel('Overall market exposure, as a % of AUM', 'pdp-portfolio-overall-market-exposure'),
      id: 'marketExposureCard',
      disclosureText: data.fund.disclosures.pdpCardMarketExposure,
      placementId: 'pdpCardMarketExposure'
    },
    emeaMaturity: {
      type: 'portfolioChild',
      breakdown: data.fund.emeaMaturity,
      header: 'Maturity breakdown',
      id: 'maturityBreakdownCard'
    },
    emeaCurrencyBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.emeaCurrencyBreakdown,
      header: _string_utility2.default.renderFormattedLabel('Currency breakdown', 'pdp-portfolio-currency-breakdown', { role: data.role }),
      id: 'currencyBreakdownCard',
      secondDisclosureText: secondDisclosureText,
      secondPlacementId: secondPlacementId
    },
    currencyHedgePortfolio: {
      type: 'portfolioChild',
      breakdown: data.fund.currencyHedgePortfolio,
      header: _string_utility2.default.renderFormattedLabel('Currency Hedge Portfolio', 'pdp-portfolio-currency-hedge-portfolio'),
      id: 'currencyHedgePortfolioCard',
      effectiveDate: propOrEmptyObject(data.fund.currencyHedgePortfolio).effectiveDate,
      subColumnHeader: [_string_utility2.default.renderFormattedLabel("Contract Descripter", "pdp-portfolio-currency-hedge-portfolio-column-header1"), _string_utility2.default.renderFormattedLabel("Contract Rate", "pdp-portfolio-currency-hedge-portfolio-column-header2"), _string_utility2.default.renderFormattedLabel("Settlement Date", "pdp-portfolio-currency-hedge-portfolio-column-header3"), _string_utility2.default.renderFormattedLabel("Value to Pay", "pdp-portfolio-currency-hedge-portfolio-column-header4"), _string_utility2.default.renderFormattedLabel("Value to Receive", "pdp-portfolio-currency-hedge-portfolio-column-header5"), _string_utility2.default.renderFormattedLabel("Unrealised P&L (AUD)", "pdp-portfolio-currency-hedge-portfolio-column-header6")]
    },
    currentPositioning: {
      type: 'portfolioChild',
      breakdown: data.fund.currentPositioning,
      header: _string_utility2.default.renderFormattedLabel('Current positioning', 'pdp-portfolio-current-positioning'),
      id: 'currentPositioningCard',
      grouping: true,
      secondDisclosureText: secondDisclosureText,
      secondPlacementId: secondPlacementId
    },
    regionalBreakdownEquityAndFixedIncome: {
      type: 'portfolioChild',
      breakdown: data.fund.regionalBreakdownEquityAndFixedIncome,
      header: _string_utility2.default.renderFormattedLabel('Regional breakdown', 'pdp-portfolio-regional-breakdown', { role: data.role }),
      id: 'emeaRegionalBreakdownEquityAndFixedCard',
      grouping: true,
      disclosureText: data.fund.disclosures.pdpCardRegionalBreakdown,
      placementId: 'pdpCardRegionalBreakdown'
    },
    sectorBreakdownByFixedIncome: {
      type: 'portfolioChild',
      breakdown: data.fund.sectorBreakdownByFixedIncome,
      header: _string_utility2.default.renderFormattedLabel('Sector breakdown - fixed income', 'pdp-portfolio-sector-breakdown-fixed-income'),
      id: 'sectorBreakdownByFixedIncomeCard'
    },
    portfolioAnalysisByEquity: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisByEquity,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Analysis - By Equity", "pdp-portfolio-analysis-by-equity"),
      id: 'portfolioAnalysisByEquityCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioAnalysisByEquity,
      placementId: "pdpCardPortfolioAnalysisByEquity"
    },
    portfolioAnalysisByEquitySector: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisByEquitySector,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Analysis - By Equity", "pdp-portfolio-analysis-by-equity-sector"),
      id: 'portfolioAnalysisByEquitySectorCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioAnalysisByEquity,
      placementId: "pdpCardPortfolioAnalysisByEquity"
    },
    portfolioAnalysisByEquitySectorCifm: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisByEquitySectorCIFM,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Analysis - By Equity Sector (Percentage of NAV)", "pdp-portfolio-analysis-by-equity-sector-cifm"),
      id: 'portfolioAnalysisByEquitySectorCIFMCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioAnalysisByEquity,
      placementId: "pdpCardPortfolioAnalysisByEquityCIFM"
    },
    portfolioAnalysisByEquityRegions: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisByEquityRegions,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Analysis - By Equity", "pdp-portfolio-analysis-by-equity-regions"),
      id: 'portfolioAnalysisByEquityRegionsCard',
      disclosureText: data.fund.disclosures.pdpCardPortfolioAnalysisByEquity,
      placementId: "pdpCardPortfolioAnalysisByEquity"
    },
    portfolioAnalysisByCurrency: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisByCurrency,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Analysis - By Currency", "pdp-portfolio-analysis-by-currency"),
      id: 'portfolioAnalysisByCurrencyCard'
    },
    summaryPortfolioStats: {
      type: 'portfolioChild',
      breakdown: data.fund.summaryPortfolioStats,
      header: _string_utility2.default.renderFormattedLabel('Summary portfolio statistics', 'pdp-portfolio-summary-portfolio-statistics'),
      id: 'portfolioSummaryPortfolioStatistics',
      effectiveDate: _date_formatter2.default.getDateInSpecificFormat(propOrEmptyObject(data.fund.summaryPortfolioStats).effectiveDate, 'MMMM YYYY')
    },
    valueAtRiskBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.shareClass.valueAtRiskBreakdown,
      header: _string_utility2.default.renderFormattedLabel('Value at Risk (VaR)', 'pdp-portfolio-var'),
      id: 'valueAtRiskBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardVaR,
      placementId: 'valueAtRiskBreakdown',
      subColumnHeader: (0, _ramda.isNil)(data.fund.shareClass.valueAtRiskBreakdown) || (0, _ramda.isNil)(data.fund.shareClass.valueAtRiskBreakdown.data[0].secondaryValue) ? ["", _string_utility2.default.renderFormattedLabel('Fund', 'Fund')] : ["", _string_utility2.default.renderFormattedLabel('Fund', 'Fund'), _string_utility2.default.renderFormattedLabel('Benchmark', 'Benchmark')]
    },
    portAllocMms: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAllocationMMS,
      header: 'Portfolio Allocation',
      id: 'portfolioAllocationMmsCard',
      subColumnHeader: ["", _string_utility2.default.renderFormattedLabel('NET', 'pdp-portfolio-net-label'), _string_utility2.default.renderFormattedLabel('GROSS', 'pdp-portfolio-gross-label')]
    },
    companyTypeExposure: {
      type: 'portfolioChild',
      breakdown: data.fund.companyTypeExposure,
      header: 'Company type exposure',
      id: 'companyTypeExposureCard',
      subColumnHeader: ['', 'Weight', 'Average delta']
    },
    bondQualityCbBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.bondQualityCbBreakdown,
      header: _string_utility2.default.renderFormattedLabel('Convertible bond arbitrage', 'pdp-portfolio-convertible-bond-arbitrage'),
      id: 'bondQualityCbBreakdownCard',
      subColumnHeader: (0, _functional_utility3.doesVisibleDataPointContains)('CONVERTIBLE_BOND_ARBITRAGE_SHOULD_NOT_SHOW_SUBHEADER', data.fund.visibleData, ['visibleDataPoints']) ? [] : [_string_utility2.default.renderFormattedLabel("Bond quality breakdown", 'pdp-portfolio-bond-quality-label')],
      placementId: 'pdpCardQualityBreakdown',
      disclosureText: data.fund.disclosures.pdpCardQualityBreakdown
    },
    portfolioAnalysisByFixedIncome: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisByFixedIncome,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Analysis - By Fixed Income", "pdp-portfolio-analysis-by-fixed-income"),
      id: 'portfolioAnalysisByFixedIncomeCard',
      effectiveDate: _date_formatter2.default.getDateInSpecificFormat(propOrEmptyObject(data.fund.portfolioAnalysisByFixedIncome).effectiveDate)
    },
    portfolioAnalysisByFixedIncomeRegions: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisByFixedIncomeRegions,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Analysis - By Fixed Income", "pdp-portfolio-analysis-by-fixed-income-regions"),
      id: 'portfolioAnalysisByFixedIncomeRegionsCard',
      effectiveDate: _date_formatter2.default.getDateInSpecificFormat(propOrEmptyObject(data.fund.portfolioAnalysisByFixedIncomeRegions).effectiveDate)
    },
    portfolioAnalysisByFixedIncomeSector: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisByFixedIncomeSector,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Analysis - By Fixed Income", "pdp-portfolio-analysis-by-fixed-income-sector"),
      id: 'portfolioAnalysisByFixedIncomeSectorCard',
      effectiveDate: _date_formatter2.default.getDateInSpecificFormat(propOrEmptyObject(data.fund.portfolioAnalysisByFixedIncomeSector).effectiveDate)
    },
    portfolioAnalysisByDenominatedCurrency: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisByDenominatedCurrency,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Analysis - By Currency of Denomination", "pdp-portfolio-analysis-by-denominated-currency"),
      id: 'portfolioAnalysisByDenominatedCurrencyCard',
      grouping: false
    },
    exposureCard: {
      type: 'portfolioChild',
      breakdown: data.fund.assetExposure,
      header: _string_utility2.default.renderFormattedLabel("Asset exposure", (0, _ramda.includes)("SHOW_PORTFOLIO_ANALYSIS_BY_ASSET", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? "pdp-portfolio-analysis-by-asset" : "pdp-portfolio-analysis-by-asset-class"),
      id: 'assetExposureCard',
      disclosureText: (0, _ramda.includes)("SHOW_PORTFOLIO_ANALYSIS_BY_ASSET", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? null : data.fund.disclosures.pdpPortfolioAssetClass,
      placementId: "pdpAssetExposureBreakdown",
      subColumnHeader: (0, _ramda.includes)("SHOW_ASSET_EXPOSURE_SUB_COLUMN_HEADER", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? ["Asset", "Weight", "Yield"] : null
    },
    sectorEquityCard: {
      type: 'portfolioChild',
      breakdown: data.fund.equitySector,
      header: _string_utility2.default.renderFormattedLabel("Equity Sector", "pdp-portfolio-analysis-by-equity-sector"),
      id: 'equitySectorCard'
    },
    bondTypeCard: {
      type: 'portfolioChild',
      breakdown: data.fund.bondType,
      header: _string_utility2.default.renderFormattedLabel("Bond Type", "pdp-portfolio-analysis-by-bond-type"),
      id: 'bondTypeCard'
    },
    historicalHoldings: {
      type: 'holdingCard',
      breakdown: propOrEmptyObject(data.historicalData).historicalHoldings,
      header: _string_utility2.default.renderFormattedLabel("All Holdings", "pdp-all-holdings-header"),
      id: 'allHoldingsCard'
    },
    dailyHoldings: {
      type: 'detailedHolding',
      breakdown: data.fund.dailyHoldings,
      header: "pdp-daily-holdings-header",
      id: 'dailyHoldingsCard',
      disclosureText: (0, _ramda.includes)("SHOW_PORTFOLIO_HOLDINGS_DISCLOSURE", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? data.fund.disclosures.pdpPortfolioTopHoldings : data.fund.disclosures.pdpCardTop10Holdings,
      placementId: "pdpCardTop10Holdings",
      effectiveDate: propOrEmptyObject(data.fund.dailyHoldings).effectiveDate,
      currencyCode: data.fund.currencyCode,
      visibleTopHoldings: propOrEmptyObject(data.fund.visibleData).visibleTopHoldings,
      showDownloadButton: (0, _functional_utility3.doesVisibleDataPointContains)('DETAILED_HOLDINGS_EXCEL_AND_PDF_DOWNLOAD', data.fund.visibleData, ['visibleDataPoints']) || !(0, _functional_utility3.doesVisibleDataPointContains)('SEMI_TRANSPARENT_INDICATOR_PRESENT', data.fund.visibleData, ['visibleDataPoints']),
      additionalCheck: !(0, _ramda.isNil)(data.fund.dailyHoldings)
    },
    underlyingFundStatistics: {
      type: "portfolioChild",
      breakdown: data.fund.underlyingFundStatistics,
      header: _string_utility2.default.renderFormattedLabel('Underlying Fund Statistics', 'pdp-portfolio-underlying-fund-statistics'),
      id: "underlyingFundStatisticsCard",
      grouping: true
    },
    underlyingHoldings: {
      type: 'detailedHolding',
      breakdown: data.fund.underlyingHoldings,
      header: "pdp-underlying-holdings-header",
      id: 'underlyingHoldingsCard',
      disclosureText: (0, _ramda.includes)("SHOW_PORTFOLIO_HOLDINGS_DISCLOSURE", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? data.fund.disclosures.pdpPortfolioTopHoldings : data.fund.disclosures.pdpCardTop10Holdings,
      placementId: "pdpCardUnderlyingHoldings",
      effectiveDate: propOrEmptyObject(data.fund.underlyingHoldings).effectiveDate,
      currencyCode: data.fund.currencyCode,
      visibleUnderlyingHoldings: propOrEmptyObject(data.fund.visibleData).visibleUnderlyingHoldings,
      showDownloadButton: true,
      additionalCheck: !(0, _ramda.isNil)(data.fund.underlyingHoldings)
    },
    proxyHoldings: {
      type: 'detailedHolding',
      breakdown: data.fund.proxyHoldings,
      header: "pdp-daily-proxy-holdings-header",
      id: 'proxyHoldingsCard',
      disclosureText: data.fund.disclosures.pdpCardProxyPortfolioHoldings,
      placementId: "pdpCardProxyPortfolioHoldings",
      effectiveDate: propOrEmptyObject(data.fund.proxyHoldings).effectiveDate,
      currencyCode: data.fund.currencyCode,
      visibleProxyHoldings: propOrEmptyObject(data.fund.visibleData).visibleProxyHoldings,
      showDownloadButton: (0, _functional_utility3.doesVisibleDataPointContains)('DETAILED_PROXY_HOLDINGS_EXCEL_AND_PDF_DOWNLOAD', data.fund.visibleData, ['visibleDataPoints']) || !(0, _functional_utility3.doesVisibleDataPointContains)('SEMI_TRANSPARENT_INDICATOR_PRESENT', data.fund.visibleData, ['visibleDataPoints']),
      additionalCheck: !(0, _ramda.isNil)(data.fund.proxyHoldings)
    },
    emeaFundHoldings: {
      type: 'detailedHolding',
      breakdown: data.fund.emeaFundHoldings,
      header: "pdp-top-holdings-header",
      id: 'emeaHoldingsCard',
      disclosureText: (0, _ramda.includes)("SHOW_PORTFOLIO_HOLDINGS_DISCLOSURE", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? data.fund.disclosures.pdpPortfolioTopHoldings : data.fund.disclosures.pdpCardTop10Holdings,
      placementId: "pdpCardTop10Holdings",
      effectiveDate: propOrEmptyObject(data.fund.emeaFundHoldings).effectiveDate,
      currencyCode: data.fund.currencyCode,
      visibleTopHoldings: propOrEmptyObject(data.fund.emeaFundHoldings).visibleFields,
      showDownloadButton: (0, _ramda.includes)("SHOW_TOP_HOLDING_DOWNLOAD", _functional_utility2.default.pathOrEmptyArray(["visibleDataPoints"], data)) ? true : false,
      additionalCheck: !(0, _ramda.isNil)(data.fund.emeaFundHoldings)
    },
    emeaRegionalBreakdownCard: {
      type: 'portfolioChild',
      breakdown: data.fund.emeaRegionalBreakdown,
      header: _string_utility2.default.renderFormattedLabel('Regional breakdown', 'pdp-portfolio-regional-breakdown', { role: data.role }),
      id: 'emeaRegionalBreakdownCard',
      subColumnHeader: renderSubColumnHeadingsForRegionalBreakDown(data.fund.emeaRegionalBreakdown, (0, _functional_utility3.doesVisibleDataPointContains)('PORTFOLIO_REGIONAL_BREAKDOWN_HEADER', data.fund.visibleData, ['formattingRules'])),
      additionalCheck: (0, _ramda.isNil)(data.fund.mergerArbitrageMetrics) || (0, _ramda.isNil)(data.fund.mergerArbitrageDealType),
      disclosureText: data.fund.disclosures.pdpCardRegionalBreakdown,
      placementId: 'pdpCardRegionalBreakdown',
      secondDisclosureText: secondDisclosureText,
      secondPlacementId: secondPlacementId
    },
    mergerArbitrage: {
      type: 'tabbedCard',
      breakdown: [{
        id: "mergerArbitrageCardMetrics",
        label: _string_utility2.default.renderFormattedLabel("Metrics", 'pdp-portfolio-metrics'),
        breakdownListData: data.fund.mergerArbitrageMetrics
      }, {
        id: "mergerArbitrageCardDealTypes",
        label: _string_utility2.default.renderFormattedLabel("Deal types", 'pdp-portfolio-deal-types'),
        breakdownListData: data.fund.mergerArbitrageDealType
      }, {
        id: "mergerArbitrageCardRegions",
        label: _string_utility2.default.renderFormattedLabel("Regions", 'pdp-portfolio-regions'),
        breakdownListData: data.fund.emeaRegionalBreakdown,
        subColumnHeader: renderSubColumnHeadingsForRegionalBreakDown(data.fund.emeaRegionalBreakdown)
      }],
      header: _string_utility2.default.renderFormattedLabel('Merger arbitrage', 'pdp-portfolio-merger-arbitrage'),
      id: 'mergerArbitrage',
      additionalCheck: !((0, _ramda.isNil)(data.fund.mergerArbitrageMetrics) || (0, _ramda.isNil)(data.fund.mergerArbitrageDealType))
    },
    riskBreakdown: {
      type: 'tabbedCard',
      breakdown: [{
        id: "riskBreakdown-themeRiskBreakdown",
        label: _string_utility2.default.renderFormattedLabel("Theme risk", 'pdp-portfolio-theme-risk'),
        breakdownListData: data.fund.themeRiskBreakdown
      }, {
        id: "riskBreakdown-regionalRiskBreakdown",
        label: _string_utility2.default.renderFormattedLabel("Regional risk", 'pdp-portfolio-regional-risk'),
        breakdownListData: data.fund.regionalRiskBreakdown
      }, {
        id: "riskBreakdown-assetClassRiskBreakdown",
        label: _string_utility2.default.renderFormattedLabel("Asset class risk", 'pdp-portfolio-asset-class-risk'),
        breakdownListData: data.fund.assetClassRiskBreakdown
      }],
      header: _string_utility2.default.renderFormattedLabel("Risk breakdown", 'pdp-portfolio-risk-breakdown', { role: data.role }),
      id: 'riskBreakdown',
      disclosureText: data.fund.disclosures.pdpCardRiskBreakdown,
      placementId: 'pdpCardRiskBreakdown',
      secondDisclosureText: secondDisclosureText,
      secondPlacementId: secondPlacementId
    },
    equityLongShort: {
      type: 'tabbedCard',
      breakdown: [{
        id: "equityLongShortOpenPositions",
        label: _string_utility2.default.renderFormattedLabel("Total positions", 'pdp-portfolio-total-positions'),
        breakdownListData: data.fund.equityLongShortOpenPositions
      }, {
        id: "equityLongShortCardMarketCap",
        label: _string_utility2.default.renderFormattedLabel("Market cap", 'portfolio-market-cap'),
        breakdownListData: data.fund.equityLongShortMarketCap,
        subColumnHeader: (0, _ramda.call)(function () {
          var headers = (0, _ramda.propOr)([], ["headers"], data.fund.equityLongShortMarketCap);
          var formattedHeaders = (0, _ramda.compose)((0, _ramda.map)(function (header) {
            return _string_utility2.default.renderFormattedLabel(header.replace(/_value/gi, ""), 'pdp-portfolio-' + (0, _ramda.toLower)(header.replace(/_value/gi, "")) + '-label');
          }), (0, _ramda.map)(function (text) {
            return (0, _ramda.concat)((0, _ramda.head)(text), (0, _ramda.toLower)((0, _ramda.tail)(text)));
          }))(headers);

          return (0, _ramda.concat)([""], formattedHeaders);
        })
      }, {
        id: "equityLongShortCardRegionsSectorExposure",
        label: _string_utility2.default.renderFormattedLabel('Sector exposure', 'pdp-portfolio-sector-exposure'),
        breakdownListData: data.fund.emeaSectorExposure,
        subColumnHeader: renderSubColumnHeadingsForExposureBreakDown(data.fund.emeaSectorExposure, "Sector")
      }],
      header: _string_utility2.default.renderFormattedLabel("Equity long/short", 'pdp-portfolio-equity-long-short'),
      id: 'equityLongShort',
      additionalCheck: !(0, _ramda.isNil)(data.fund.equityLongShortOpenPositions) && !(0, _ramda.isNil)(data.fund.equityLongShortMarketCap) && !(0, _ramda.isNil)(data.fund.emeaSectorExposure)
    },
    weeklyMaturityBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.weeklyMaturityBreakdown,
      header: _string_utility2.default.renderFormattedLabel('Maturity breakdown', 'pdp-portfolio-maturity-breakdown'),
      id: 'weeklyMaturityBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardMaturity,
      placementId: 'pdpCardMaturity'
    },
    portfolioAnalysisByConvertibleBonds: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisByConvertibleBonds,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Analysis - Convertible Bonds", "pdp-portfolio-analysis-by-convertible_bonds"),
      id: 'portfolioAnalysisByConvertibleBondsCard',
      effectiveDate: _date_formatter2.default.getDateInSpecificFormat(propOrEmptyObject(data.fund.portfolioAnalysisByConvertibleBonds).effectiveDate)
    },
    portfolioAnalysisNetLiquidity: {
      type: 'portfolioChild',
      breakdown: data.fund.portfolioAnalysisNetLiquidity,
      header: _string_utility2.default.renderFormattedLabel("Portfolio Analysis - Net Liquidity", "pdp-portfolio-analysis-by-net_liquidity"),
      id: 'portfolioAnalysisNetLiquidityCard',
      effectiveDate: _date_formatter2.default.getDateInSpecificFormat(propOrEmptyObject(data.fund.portfolioAnalysisNetLiquidity).effectiveDate)
    },
    globalEquitySectors: {
      type: 'portfolioChild',
      breakdown: data.fund.globalEquitySectors,
      header: _string_utility2.default.renderFormattedLabel("Global equity sectors", "pdp-portfolio-global-equity-sectors"),
      id: 'globalEquitySectors',
      effectiveDate: _date_formatter2.default.getDateInSpecificFormat(propOrEmptyObject(data.fund.globalEquitySectors).effectiveDate),
      subColumnHeader: ["", _string_utility2.default.renderFormattedLabel("Fund", 'Fund')]
    },
    marketExp: {
      type: 'portfolioChild',
      breakdown: data.fund.emeaMarketExposure,
      header: _string_utility2.default.renderFormattedLabel('Market exposure', 'pdp-portfolio-market-exposure'),
      id: 'emeaMarketExposureCard',
      effectiveDate: propOrEmptyObject(data.fund.emeaMarketExposure).effectiveDate,
      subColumnHeader: [_string_utility2.default.renderFormattedLabel('Category', 'pdp-portfolio-category-label'), _string_utility2.default.renderFormattedLabel('Long', 'pdp-portfolio-long-label'), _string_utility2.default.renderFormattedLabel('Short', 'pdp-portfolio-short-label')]
    },
    totalPositions: {
      type: 'portfolioChild',
      breakdown: data.fund.equityLongShortOpenPositions,
      header: _string_utility2.default.renderFormattedLabel('Total Positions', 'pdp-portfolio-total-positions'),
      id: 'totalPositionsCard',
      additionalCheck: (0, _ramda.isNil)(data.fund.emeaSectorExposure) || (0, _ramda.isNil)(data.fund.equityLongShortMarketCap),
      placementId: 'pdpTotalPositions'
    },
    investmentTypeBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.investmentStrategyBreakdown,
      header: 'Investment Type Breakdown',
      id: 'investmentTypeBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardInvestmentTypeBreakdown,
      placementId: 'pdpCardInvestmentTypeBreakdown'
    },
    investmentStrategyBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.investmentStrategyBreakdown,
      header: 'TCF Investment strategies breakdown',
      id: 'investmentStrategyBreakdownCard'
    },
    strategyBreakdown: {
      type: 'portfolioChild',
      breakdown: data.fund.strategyBreakdown,
      header: 'Strategy Breakdown',
      id: 'strategyBreakdownCard',
      disclosureText: data.fund.disclosures.pdpCardStrategyBreakdown,
      placementId: 'pdpCardStrategyBreakdown'
    }
  };
};

exports.getFundPortfolioConfig = getFundPortfolioConfig;